import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import Switch from "components/Switch/Switch";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import { dateFormat } from "utils";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import Tooltip from "components/Tooltip/Tooltip";
import { getCenters, updateCenterStatus } from "services/centers";
// import AddCenter from "./AddCenter";
// import UpdateCenter from "./UpdateCenter";
// import CenterLinkModal from "./sections/CenterLinkModal";
import { Table } from "react-bootstrap";
import IconButton from "components/Button/IconButton";
import { useAdminAuth } from "context/context";
import { getMasterStates, updateMasterStateStatus } from "services/citypages";
import AddMasterState from "./AddMasterState";
import UpdateMasterState from "./UpdateMasterState";

const MasterStates = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    let activePage = +searchParam.get("page") || 1;

    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);

    const { roles } = useAdminAuth();

    const [assignStatus, setAssignStatus] = useState({
        course: false,
        faq: false,
        video: false,
        image: false,
    });

    const [galleryImage, setGalleryImage] = useState([]);

    const [blockModal, setBlockModal] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [linkModal, setLinkModal] = useState(false);
    const [linkSelectedId, setLinkSelectedId] = useState("");

    const [addModal, setAddModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [search, setSearch] = useState(searchParam.get("query") || "");
    const debounceValue = useDebounce(search || "", 300);

    //**********centre Listing**********/
    const masterstatesListing = async (page = activePage, search = debounceValue) => {
        try {
            showLoader();
            const res = await getMasterStates({
                page,
                search,
            });
            hideLoader();
            if (res.code === 200) {
                const { rows, count } = res.data.masterstates;
                setRecord(rows || []);
                setTotal(count || 0);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    // update status function
    const updateMasterStateHandler = async () => {
        if (selectedId) {
            try {
                setSubmitLoading(true);
                const res = await updateMasterStateStatus({
                    id: selectedId,
                    status: selectedStatus ? 0 : 1,
                });
                if (res.code === 200) {
                    masterstatesListing();
                    toast.success(res.message);
                    setBlockModal(false);
                    setSubmitLoading(false);
                } else {
                    toast.error(res.message);
                    setSubmitLoading(false);
                }
            } catch (err) {
                toast.error(err?.response?.data?.message || err.message);
                setSubmitLoading(false);
            }
        }
    };

    // open link modal function
    const openLinkModalHandler = (data) => {
        setLinkSelectedId(data.id);
        setAssignStatus({
            course: data.isAssignedCourse,
            faq: data.isAssignedFaq,
            video: data.isAssignedVideo,
            image: data.isAssignedImage,
        });
        setGalleryImage(data.centerImage);
        setLinkModal(true);
    };

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };

    //********Reset Filter****** */
    const restFilter = () => {
        setSearch("");
    };

    useEffect(() => {
        if (debounceValue) {
            searchParam.set("query", debounceValue);
        } else {
            searchParam.delete("query");
        }
        if (activePage === 1) {
            searchParam.delete("page");
        }
        setSearchParam(searchParam);
        masterstatesListing(activePage, debounceValue);
        // eslint-disable-next-line
    }, [searchParam, debounceValue]);

    useEffect(() => {
        if (search) {
            searchParam.set("page", "");
        }
        // eslint-disable-next-line
    }, [search]);

    return (
        <React.Fragment>
            <title>Shubhra Viraj | Master States</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox">
                                <div className="div_wrap">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        name="search"
                                        className="form-control"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                <Button className="refresh_btnn mx-2" onClick={restFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>
                                <div>
                                    <Button
                                        onClick={() => setAddModal(true)}
                                        type="acl"
                                        role={850002}
                                    >
                                        New Record
                                    </Button>
                                </div>
                            </div>
                            <h4 className="Title">Master States</h4>
                        </div><br/>
                        <div
                            style={{
                                backgroundColor: "#fdecea", // faint red
                                color: "#d93025",          // red text
                                padding: "10px 15px",
                                borderRadius: "5px",
                                fontSize: "14px",
                                marginBottom: "15px",
                            }}
                        >
                            <strong>Note:</strong> Enquiries of all the cities under the state will be shown to the default center
                        </div>
                        <div className="TableList overflow-auto table-responsive" style={{paddingTop:"0px"}}>
                            {loader}
                            <Table bordered className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>State Name</th>
                                        <th>Code</th>
                                        <th>Default Center</th>
                                        <th style={{ textAlign: "center" }}>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {record && record.length > 0 ? (
                                        record.map(
                                            (
                                                {
                                                    id,
                                                    statename,
                                                    statecode,
                                                    centerid,
                                                    centername,
                                                    status,

                                                },
                                                i
                                            ) => (
                                                <tr key={i}>
                                                    <td>{++i + (activePage - 1) * 10}</td>
                                                    <td>
                                                        <Tooltip title={statename}>
                                                            <div className="">{statename}</div>
                                                        </Tooltip>
                                                    </td>
                                                    <td>{statecode}</td>
                                                    <td>{centername}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <Switch
                                                            checked={status}
                                                            onChange={() => {
                                                                setSelectedId(id);
                                                                setSelectedStatus(status);
                                                                setBlockModal(true);
                                                            }}
                                                            type="acl"
                                                            role={170005}
                                                        />
                                                    </td>

                                                    <td>
                                                        <div className="d-flex justify-content-center">
                                                            <IconButton
                                                                aria-label="view"
                                                                className="px-2 py-0"
                                                                onClick={() => {
                                                                    setSelectedData({
                                                                        id,
                                                                        statename,
                                                                        statecode,
                                                                        centerId: centerid,
                                                                        centername,
                                                                    });
                                                                    setUpdateModal(true);
                                                                }}
                                                                type="acl"
                                                                role={170002}
                                                            >
                                                                <EditIcon sx={{ color: "#4971B2" }} />
                                                            </IconButton>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    ) : (
                                        <NotFound cols={12} />
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        {total > 10 ? (
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            {/* block or unblock model */}
            <ModalBox
                status={blockModal}
                onClose={() => setBlockModal(false)}
                title={"Change Status"}
                description={"You want to change status of this state?"}
                customizedFooter={
                    <Button onClick={updateMasterStateHandler} {...submitButtonElement}>
                        Yes
                    </Button>
                }
            />

            <AddMasterState
                open={addModal}
                onClose={() => setAddModal(false)}
                masterstatesListing={masterstatesListing}
            />

            <UpdateMasterState
                open={updateModal}
                onClose={() => setUpdateModal(false)}
                selectedData={selectedData}
                masterstatesListing={masterstatesListing}
            />

        </React.Fragment>
    );
};

export default MasterStates;
